import React, { useContext, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import LayoutContext from 'components/Layout/LayoutContext';
import PrivateContainer from 'components/PrivateContainer';
import Player from 'components/Player/Player';

interface Params {
  url: string;
}

const useStyle = makeStyles(
  (theme: Theme) =>
    createStyles({
      content: {
        display: 'flex',
        justifyContent: 'center',
        margin: theme.spacing(4, 'auto'),
        [theme.breakpoints.up('lg')]: {
          maxWidth: '50%',
        },
      },
    }),
  { name: 'AssessorTransmissao' }
);

export default function AssessorTransmissao() {
  const classes = useStyle();
  const location = useLocation();
  const { setToolbarReadOnly } = useContext(LayoutContext);

  const url = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('url');
  }, [location]);

  useEffect(() => {
    setToolbarReadOnly(true);
    return () => {
      setToolbarReadOnly(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PrivateContainer contentClassName={classes.content}>
      {url && <Player url={url} autoPlay />}
    </PrivateContainer>
  );
}
